import { combineReducers } from 'redux';
import CarrierRegistrationReducer from './CarrierRegistration/CarrierRegistrationReducer';
import LossAndDamageClaimsReducer from './Claims/LossAndDamage/LossAndDamageClaimsReducer';
import OverChargeClaimsReducer from './Claims/OverCharge/OverChargeReducer';
import PreClaimsReducer from './Claims/PreClaims/PreClaimsReducer';
import DashboardReducer from './Dashboard/DashboardReducer';
import MessageCenterReducer from './MessageCenter/MessageCenterReducer';
import POShipmentDraftSearchReducer from './POShipmentDraftSearch/POShipmentDraftSearchReducer';
import POShipmentPreBookingSearchReducer from './POShipmentPreBookingSearch/POShipmentPreBookingSearchReducer';
import POShipmentSearchReducer from './POShipmentSearch/POShipmentSearchReducer';
import POVReducer from './POV/POVReducer';
import ProcurementProjectReducer from './Procurement/Project/ProcurementProjectReducer';
import ProcurementLaneReducer from './Procurement/RouteConfig/Lane/ProcurementLaneReducer';
import ProcurementLocationReducer from './Procurement/RouteConfig/Location/ProcurementLocationReducer';
import ProcurementZoneReducer from './Procurement/RouteConfig/Zone/ProcurementZoneReducer';
import ProcurementTenderReducer from './Procurement/Tender/ProcurementTenderReducer';
import RateShopReducer from './RateShop/RateShopReducer';
import RoutingGuideReducer from './RoutingGuide/RoutingGuideReducer';
import SaversReducer from './Savers/SaversReducer';
import AuctionReducer from './auction/AuctionReducer';
import AuthReducer from './auth/AuthReducer';
import CommonReducer from './common/CommonReducer';
import LookupsReducer from './lookups/LookupsReducer';
import PurchaseOrderReducer from './purchaseOrder/PurchaseOrderReducer';
import SettingsReducer from './settings/SettingsReducer';
import ShipmentReducer from './shipment/ShipmentReducer';
import VisibilityReducer from './visibility/VisibilityReducer';

export type RootState = ReturnType<typeof rootReducer>;

const appReducer = combineReducers({
  common: CommonReducer,
  auth: AuthReducer,
  dashboard: DashboardReducer,
  carrierRegistration: CarrierRegistrationReducer,
  shipment: ShipmentReducer,
  purchaseOrder: PurchaseOrderReducer,
  poVendor: POVReducer,
  auction: AuctionReducer,
  settings: SettingsReducer,
  visibility: VisibilityReducer,
  lookups: LookupsReducer,
  rateShop: RateShopReducer,
  procurementProject: ProcurementProjectReducer,
  procurementTender: ProcurementTenderReducer,
  poShipmentSearch: POShipmentSearchReducer,
  procurementLocation: ProcurementLocationReducer,
  procurementLane: ProcurementLaneReducer,
  procurementZone: ProcurementZoneReducer,
  poShipmentDraftSearch: POShipmentDraftSearchReducer,
  poShipmentPreBookingSearch: POShipmentPreBookingSearchReducer,
  routingGuide: RoutingGuideReducer,
  overChargeClaims: OverChargeClaimsReducer,
  messageCenter: MessageCenterReducer,
  preClaims: PreClaimsReducer,
  lossAndDamage: LossAndDamageClaimsReducer,
  savers: SaversReducer,
});

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};
export default rootReducer;
